import { Building2, Calculator, FileCheck2, FileText, Globe2, Landmark, Users } from "lucide-react";

const SERVICES = [
  {
    icon: Calculator,
    title: "Monotributo",
    description:
      "Alta, gestión, recategorización y baja de monotributo con acompañamiento profesional.",
  },
  {
    icon: FileCheck2,
    title: "Regularización fiscal",
    description:
      "Análisis y regularización de deuda, situación fiscal y obligaciones pendientes.",
  },
  {
    icon: Users,
    title: "Liquidación de sueldos",
    description:
      "Liquidación salarial, cargas sociales y cumplimiento laboral para pymes, comercios y profesionales.",
  },
  {
    icon: FileText,
    title: "Impuestos mensuales",
    description:
      "Presentación de declaraciones juradas de IVA e Ingresos Brutos.",
  },
  {
    icon: Landmark,
    title: "Impuestos anuales",
    description:
      "Liquidación y presentación de Ganancias y Bienes Personales.",
  },
  {
    icon: Building2,
    title: "Sociedades",
    description:
      "Constitución, gestión contable, asesoramiento impositivo y acompañamiento para empresas.",
  },
  {
    icon: Globe2,
    title: "Exportación de servicios",
    description:
      "Asesoramiento sobre facturación, cobranzas en moneda extranjera y gestión vinculada al exterior.",
  },
];

export const Services = () => {
  return (
    <section
      id="servicios"
      data-testid="services-section"
      aria-label="Servicios contables online para Buenos Aires y CABA"
      className="bg-cream-300 py-16 md:py-24"
    >
      <div className="container mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-12 text-center md:mb-16">
          <span className="mb-3 inline-block font-poppins text-sm font-medium uppercase tracking-wide text-gold">
            Servicios
          </span>
          <h2 className="mb-4 font-poppins text-3xl font-semibold text-navy-900 md:text-4xl lg:text-5xl">
            Servicios contables e impositivos
          </h2>
          <p className="mx-auto max-w-2xl font-inter text-base text-navy-700 md:text-lg">
            Atención a emprendedores, profesionales y empresas con gestión
            remota, digital y eficiente.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 md:gap-8">
          {SERVICES.map((service, i) => (
            <article
              key={service.title}
              data-testid={`service-card-${i}`}
              className="group rounded-2xl border border-navy-900/5 bg-white p-8 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg md:p-10"
            >
              <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-xl bg-gold/10 transition-colors duration-300 group-hover:bg-gold/20">
                <service.icon className="h-7 w-7 text-gold" strokeWidth={1.5} />
              </div>
              <h3 className="mb-3 font-poppins text-xl font-semibold text-navy-900">
                {service.title}
              </h3>
              <p className="font-inter text-base leading-relaxed text-navy-700">
                {service.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
